import { isFunction, isUndefined } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetPointsFeature } from 'src/hooks/useGetPointsFeature';
import { useQueryUsageInformation } from 'src/services/queries';
import { SKIP_ASK_PAY_CREDIT } from 'src/utils/constants/config';
import { LIST_FEATURES } from 'src/utils/constants/featuresPoint';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { ERROR_CODE, ERROR_CODE_MESSAGE } from 'src/utils/constants/statusCode';
import { NotifyType, useNotifyCreditCosts } from 'src/zustand/useNotifyCreditCosts';

export interface IUseCreditFlowProps {
  status_code?: number;
  response?: IResponse<any>;
  featureInfo?: {
    featureId: keyof typeof LIST_FEATURES;
    action: string;
  };
  // paymentStatus?: boolean | null | undefined;
  // isCollectingData?: boolean;
  onSetAcceptCreditPayment: (value: boolean) => void;
  acceptCreditPayment: boolean;
  cbClose?: () => void;
}

const useCreditFlow = (props: IUseCreditFlowProps) => {
  const {
    response,
    status_code,
    // paymentStatus,
    // isCollectingData,
    onSetAcceptCreditPayment,
    acceptCreditPayment,
    featureInfo,
    cbClose,
  } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const { handleOpenNotify, handleCloseNotify } = useNotifyCreditCosts((state) => state);
  const hasHistoryEntryExist = location.key !== 'default'; // false => chuyển từ 1 trang ngoài Adamftd qua
  const [hasEnoughCredit, setHasEnoughCredit] = useState(false);
  // const { data: dataUsage } = useQueryUsageInformation();

  // const creditInfo = useGetPointsFeature(featureInfo.featureId, featureInfo.action, dataUsage);

  useEffect(() => {
    if ([ERROR_CODE_MESSAGE.NOT_ENOUGH_CREDITS].includes(response?.data?.error?.code)) {
      handleOpenNotify({
        type: NotifyType.NotEnoughCredit,
        showCloseIcon: true,
        cbClose: () => {
          if (isFunction(cbClose)) {
            cbClose?.();
            return;
          }
          // Default behavior
          if (hasHistoryEntryExist) {
            navigate(-1);
          } else {
            navigate(AuthRouteKeys.Home);
          }
        },
      });
      setHasEnoughCredit(false);
      return;
    } else {
      setHasEnoughCredit(true);
    }
  }, [response?.data?.error?.code]);

  useEffect(() => {
    onSetAcceptCreditPayment(true);
  }, []);

  // useEffect(() => {
  //   // if (isCollectingData) return;
  //   // if (paymentStatus === true) return onSetAcceptCreditPayment(true);
  //   // const skipAskPayCredit = localStorage.getItem(SKIP_ASK_PAY_CREDIT);
  //
  //   // Users haven't bought plans yet.
  //   // if (!acceptCreditPayment && isUndefined(creditInfo?.planName)) {
  //   //   handleOpenNotify({
  //   //     type: NotifyType.NotEnoughCredit,
  //   //     showCloseIcon: true,
  //   //     cbClose: () => {
  //   //       if (hasHistoryEntryExist) {
  //   //         navigate(-1);
  //   //       } else {
  //   //         navigate(AuthRouteKeys.Home);
  //   //       }
  //   //     },
  //   //   });
  //   //   return;
  //   // }
  //
  //   // Users don't want show popup confirm credit expenditures.
  //   // if (!acceptCreditPayment && (skipAskPayCredit || creditInfo?.creditCosts === 0)) {
  //   //   onSetAcceptCreditPayment(true);
  //   //   return;
  //   // }
  //
  //   // if (!acceptCreditPayment && creditInfo?.creditCosts > 0) {
  //   //   handleOpenNotify({
  //   //     type: NotifyType.CreditCost,
  //   //     textBtn: 'View Profile Detail',
  //   //     creditCost: creditInfo?.creditCosts,
  //   //     showCloseIcon: true,
  //   //     cbClose: () => {
  //   //       if (hasHistoryEntryExist) {
  //   //         navigate(-1);
  //   //       } else {
  //   //         navigate(AuthRouteKeys.Home);
  //   //       }
  //   //     },
  //   //     cbAction: () => {
  //   //       onSetAcceptCreditPayment(true);
  //   //       handleCloseNotify();
  //   //     },
  //   //   });
  //   // }
  //
  //   // onSetAcceptCreditPayment(true);
  //
  // }, [
  //   // acceptCreditPayment,
  //   // paymentStatus,
  //   // creditInfo?.planName,
  //   // creditInfo?.creditCosts,
  //   // isCollectingData
  // ]);

  const shouldShowBillableDataLoading = useMemo(() => {
    return !acceptCreditPayment || [ERROR_CODE_MESSAGE.NOT_ENOUGH_CREDITS].includes(response?.data?.error?.code);
  }, [acceptCreditPayment, response?.data?.error?.code]);

  return [shouldShowBillableDataLoading, hasEnoughCredit];
};

export default useCreditFlow;
